// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TipModal_style_wrap__3NBLE","icon":"TipModal_style_icon__QxhqN","tip":"TipModal_style_tip__2CrsD"};